const SupremoCard = (props) => {
    const { btnWidth, textAlign } = props;
    const w = btnWidth ? btnWidth : "50";
    const align = textAlign ? textAlign : "text-center";

    return (
        <div className="card card-profile-1 mb-4">
            <div className={`card-body ${align}`}>
                <h4 className="m-0">Assistenza Remota</h4>
                <p className="mt-0">Scarica l'applicazione SUPREMO</p>
                <p>
                    Supremo è un’app gratuita per l’assistenza remota: ti permette di farci
                    accedere al tuo PC in modo semplice e sicuro per aiutarti in tempo reale.
                </p>
                <a
                    className={`btn btn-primary w-${w}`}
                    href="https://www.supremocontrol.com/it/supremo-download/windows"
                    download
                    target="_blank"
                    rel="noreferrer"
                >
                    <i className="i-Download"></i>&nbsp;&nbsp;Download Supremo
                </a>
            </div>
        </div>
    );
};
export default SupremoCard;